module.exports = __webpack_public_path__ + "img/Media Library-03.959e82c7.png";